import { c as _c } from "react/compiler-runtime";
import { useMutation } from '@apollo/client/react';
import { Button, Dialog, Spacer } from '@chakra-ui/react';
import { UserCoverPhotoSelector } from '@src/components/sco/Account/UserCoverPhotoSelector/index';
import { useCurrentUser } from '@src/hooks/useCurrentUser';
import { gql } from '@src/lib/gql.ts';
import { useState, useEffect } from 'react';
type UserCoverPhotoSelectorModal = {
  isOpen?: boolean;
  onClose?: () => void;
};
export const UserCoverPhotoSelectorModal = props => {
  const $ = _c(55);
  const {
    currentUser
  } = useCurrentUser();
  const [coverPhotoUrl, setCoverPhotoUrl] = useState(currentUser?.coverPhotoUrl);
  const [coverPhotoYInPercent, setCoverPhotoYInPercent] = useState(currentUser?.coverPhotoYInPercent || 50);
  const [finalPosition, setFinalPosition] = useState(currentUser?.coverPhotoYInPercent || 50);
  const [isSaving, setIsSaving] = useState(false);
  const [originalSavedPosition, setOriginalSavedPosition] = useState(currentUser?.coverPhotoYInPercent || 50);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = gql`
    mutation ($input: UpdateProfileInput!) {
      updateProfile(input: $input) {
        viewer {
          id
          currentUser {
            id
            email
            coverPhotoUrl
            coverPhotoYInPercent
          }
        }
      }
    }
  `;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [updateProfile] = useMutation(t0);
  let t1;
  if ($[1] !== coverPhotoUrl || $[2] !== currentUser || $[3] !== isSaving) {
    t1 = () => {
      if (isSaving) {
        return;
      }
      if (currentUser?.coverPhotoYInPercent !== undefined && coverPhotoUrl === currentUser?.coverPhotoUrl) {
        console.log("Modal: Updating originalSavedPosition from currentUser:", currentUser.coverPhotoYInPercent);
        setOriginalSavedPosition(currentUser.coverPhotoYInPercent);
      }
    };
    $[1] = coverPhotoUrl;
    $[2] = currentUser;
    $[3] = isSaving;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const t2 = currentUser?.coverPhotoYInPercent;
  const t3 = currentUser?.coverPhotoUrl;
  let t4;
  if ($[5] !== coverPhotoUrl || $[6] !== isSaving || $[7] !== originalSavedPosition || $[8] !== t2 || $[9] !== t3) {
    t4 = [t2, originalSavedPosition, isSaving, coverPhotoUrl, t3];
    $[5] = coverPhotoUrl;
    $[6] = isSaving;
    $[7] = originalSavedPosition;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  useEffect(t1, t4);
  let t5;
  let t6;
  if ($[11] !== coverPhotoUrl) {
    t5 = () => {
      console.log("Modal: Resetting position due to coverPhotoUrl change:", coverPhotoUrl);
      setCoverPhotoYInPercent(50);
      setFinalPosition(50);
      setOriginalSavedPosition(50);
    };
    t6 = [coverPhotoUrl];
    $[11] = coverPhotoUrl;
    $[12] = t5;
    $[13] = t6;
  } else {
    t5 = $[12];
    t6 = $[13];
  }
  useEffect(t5, t6);
  let t7;
  if ($[14] !== coverPhotoUrl || $[15] !== coverPhotoYInPercent || $[16] !== currentUser || $[17] !== props.isOpen) {
    t7 = () => {
      if (props.isOpen && currentUser) {
        console.log("Modal: Resetting to saved state on open:", {
          savedUrl: currentUser.coverPhotoUrl,
          savedPosition: currentUser.coverPhotoYInPercent,
          currentLocalUrl: coverPhotoUrl,
          currentLocalPosition: coverPhotoYInPercent
        });
        setCoverPhotoUrl(currentUser.coverPhotoUrl);
        setCoverPhotoYInPercent(currentUser.coverPhotoYInPercent || 50);
        setFinalPosition(currentUser.coverPhotoYInPercent || 50);
        setOriginalSavedPosition(currentUser.coverPhotoYInPercent || 50);
      }
    };
    $[14] = coverPhotoUrl;
    $[15] = coverPhotoYInPercent;
    $[16] = currentUser;
    $[17] = props.isOpen;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  const t8 = currentUser?.coverPhotoUrl;
  const t9 = currentUser?.coverPhotoYInPercent;
  let t10;
  if ($[19] !== props.isOpen || $[20] !== t8 || $[21] !== t9) {
    t10 = [props.isOpen, t8, t9];
    $[19] = props.isOpen;
    $[20] = t8;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  useEffect(t7, t10);
  let t11;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = position => {
      setCoverPhotoYInPercent(position.y);
    };
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  const handlePositionChange = t11;
  let t12;
  if ($[24] !== isSaving) {
    t12 = position_0 => {
      if (!isSaving) {
        setFinalPosition(position_0.y);
      }
    };
    $[24] = isSaving;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  const handleDragEnd = t12;
  let t13;
  if ($[26] !== coverPhotoUrl || $[27] !== currentUser?.email || $[28] !== finalPosition || $[29] !== props || $[30] !== updateProfile) {
    t13 = async () => {
      setIsSaving(true);
      setOriginalSavedPosition(finalPosition);
      await updateProfile({
        variables: {
          input: {
            coverPhotoUrl,
            coverPhotoYInPercent: finalPosition,
            email: currentUser?.email
          }
        }
      });
      setIsSaving(false);
      props.onClose();
    };
    $[26] = coverPhotoUrl;
    $[27] = currentUser?.email;
    $[28] = finalPosition;
    $[29] = props;
    $[30] = updateProfile;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  const handleSave = t13;
  const t14 = props.isOpen ?? false;
  let t15;
  if ($[32] !== props) {
    t15 = t16 => {
      const {
        open
      } = t16;
      if (!open) {
        props.onClose?.();
      }
    };
    $[32] = props;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <Dialog.Backdrop />;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <Dialog.CloseTrigger />;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== originalSavedPosition) {
    t18 = {
      x: 0,
      y: originalSavedPosition
    };
    $[36] = originalSavedPosition;
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  let t19;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = url => setCoverPhotoUrl(url);
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  let t20;
  if ($[39] !== coverPhotoUrl || $[40] !== handleDragEnd || $[41] !== isSaving || $[42] !== t18) {
    t20 = <UserCoverPhotoSelector disableDragEnd={isSaving} initialPosition={t18} value={coverPhotoUrl} onChange={t19} onDragEnd={handleDragEnd} onPositionChange={handlePositionChange} />;
    $[39] = coverPhotoUrl;
    $[40] = handleDragEnd;
    $[41] = isSaving;
    $[42] = t18;
    $[43] = t20;
  } else {
    t20 = $[43];
  }
  let t21;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <Spacer height={6} />;
    $[44] = t21;
  } else {
    t21 = $[44];
  }
  let t22;
  if ($[45] !== handleSave || $[46] !== isSaving) {
    t22 = <Button loading={isSaving} loadingText="Saving..." width="full" onClick={handleSave}>Save</Button>;
    $[45] = handleSave;
    $[46] = isSaving;
    $[47] = t22;
  } else {
    t22 = $[47];
  }
  let t23;
  if ($[48] !== t20 || $[49] !== t22) {
    t23 = <Dialog.Positioner><Dialog.Content bgColor="colorPalette.container" maxWidth="container.md" width="full"><Dialog.Body paddingY={12}>{t17}{t20}{t21}{t22}</Dialog.Body></Dialog.Content></Dialog.Positioner>;
    $[48] = t20;
    $[49] = t22;
    $[50] = t23;
  } else {
    t23 = $[50];
  }
  let t24;
  if ($[51] !== t14 || $[52] !== t15 || $[53] !== t23) {
    t24 = <Dialog.Root open={t14} onOpenChange={t15}>{t16}{t23}</Dialog.Root>;
    $[51] = t14;
    $[52] = t15;
    $[53] = t23;
    $[54] = t24;
  } else {
    t24 = $[54];
  }
  return t24;
};